import { queryOptions } from '@tanstack/react-query';
import type {
  GetBillingSummaryParams, RecordModalActionParams, RetrieveSquareOneSubscriptionSummaryParams,
} from '../api/saas-bff/rpc';

export const saasBff = {
  keys: {
    root: () => ['saasBff'],
    billingSummary: () => [...saasBff.keys.root(), 'getBillingSummary'],
    subscriptionSummary: () => [...saasBff.keys.root(), 'retrieveSquareOneSubscriptionSummary'],
  },

  getBillingSummary: (params: GetBillingSummaryParams) => queryOptions({
    queryKey: [...saasBff.keys.billingSummary(), { params }],
    queryFn: async () => {
      const { getBillingSummary } = await import('../api/saas-bff/rpc');
      return getBillingSummary(params);
    },
  }),

  recordModalAction: () => ({
    mutationKey: [...saasBff.keys.root(), 'recordModalAction'],
    async mutationFn(params: RecordModalActionParams) {
      const { recordModalAction } = await import('../api/saas-bff/rpc');
      return await recordModalAction(params);
    },
    meta: {
      invalidates: [saasBff.keys.subscriptionSummary()],
    },
  }),

  getSubscriptionSummary: (params: RetrieveSquareOneSubscriptionSummaryParams) => queryOptions({
    queryKey: [...saasBff.keys.subscriptionSummary(), { params }],
    queryFn: async () => {
      const { retrieveSquareOneSubscriptionSummary } = await import('../api/saas-bff/rpc');
      return retrieveSquareOneSubscriptionSummary(params);
    },
    staleTime: 7 * 24 * 60 * 60 * 1000, // 7 days
  }),
};
